<template>
  <div id="buy" >
    <div style="background-color: white" >
      <div class="select" v-for="(item, index) in list" :key="index" >
        <div class="block" v-for="(number, index) in item" :key="index" @click="selectNumber(number)" :class="{'block-select': number.active}" >
          <div>{{ number.number }}<span>场</span></div>
          <div>{{ number.money }}元</div>
        </div>
      </div>
    </div>
    <div class="customize-number" >
      <div>自定义场次</div>
      <div>
        <!--<span>请输入场次数量</span>-->
        <van-field
          clickable
          :value="number"
          placeholder="请输入场次数量"
          @input="selectNumber"
          type="number" name="number" min="1"
        />
        <!--<van-stepper v-model="number" min="1" />-->
      </div>
    </div>

    <!--
    <div class="det" >
      <p style="padding-bottom: 10px;">1. 所有场次需要使用<span>[斑马赛事通]</span> App 进行直播，请下载应用进行直播；已购买场次不可退款，请酌量购买！</p>
      <p>2. 此购买场次为<span>[自助直播场次]</span>，不提供人员直播服务。如有疑问请联系客服</p>
    </div>
    -->

    <div class="live-service" >
      <div class="live-edit" >
        <p>
          购买场次不包含视频拍摄服务，如需该服务，请点击右侧按钮前去预约，如有疑问请在线咨询工作人员。
        </p>
        <div class="btn-router" @click="routerLiveService" >拍摄服务</div>
      </div>
    </div>

    <div class="footer" >
      <div class="footer-coupon" >
        <span>已优惠 ¥{{toDecimal2(preferentialMoney)}}</span>
        <span>实付 ¥{{toDecimal2(payMoney)}} <span class="original" v-if="preferentialMoney>0">¥{{toDecimal2(payMoney+preferentialMoney)}}</span></span>
      </div>
      <van-button class="footer-pay footer-pay-active" @click="createLiveBroadcastOrder" :loading="payLoading" >立即支付 ¥{{toDecimal2(payMoney)}}</van-button>
    </div>

    <div class="coupon" >
      <div class="img" >
        <img src="@/assets/images/jian.png">
      </div>
      <div class="info" >
        <div class="money" >
          <div>累计满减</div>
          <div>-¥{{toDecimal2(preferentialMoney)}}</div>
        </div>
        <div class="text" v-if="couponFlag">您已获得累计购买20场以上部分，可享每场减{{baselinePrice - couponPrice}}元优惠</div>
        <div class="text" v-if="!couponFlag">当前购买{{showBuyCount}}场，历史已购买{{alreadyPurchasedCount}}场，本次{{showCouponCount}}场可享每场减{{baselinePrice - couponPrice}}元优惠</div>
      </div>
    </div>

    <div class="coupon" style="margin-top: 0;padding-top: 0;">
      <div class="img" >
        <img src="@/assets/images/kefu@2x.png">
      </div>
      <div class="info">
        <div class="money">
          <div>优惠咨询</div>
          <div><img class="arrow" src="@/assets/images/arrow-right@2x.png"></div>
        </div>
        <div class="text" >历史购买场次加上本次新购买场次后,总购买场次达到或超过20场,则本次新购买的场次全部可享受每场减25元的优惠。您对此优惠有任何异议，可在线询问客服</div>
      </div>
    </div>

    <div class="coupon prompt" style="margin-top: 0;padding-top: 0;">
      <div class="img" >
        <img src="@/assets/images/prompt.png">
      </div>
      <div class="info">
        <div class="money">
          <div>购买提示</div>
          <div><!--<img class="arrow" src="@/assets/images/arrow-right@2x.png">--></div>
        </div>
        <div class="text" >所有场次需要使用<span @click="reloadHref" >斑马赛事通</span>APP进行直播，请下载应用进行 直播；已购买场次不支持退款，请酌量购买。 </div>
      </div>
    </div>

    <div class="online-advisory" @click="goAgent">
      <img src="@/assets/images/human-services.png" >
    </div>

    <!-- 弹出层 这一部分暂没用到 -->
    <!--
    <van-popup
      v-model="isShowPopup"
      position="bottom"
      :style="{ height: '100%' }">
      <div class="pay-popup" >
        <div class="pay-popup-top" >
          <p>你需要支付</p>
          <div class="pay-popup-coupon" ><span>¥</span>3500.00</div>
        </div>
        <div class="line" ></div>
        <van-radio-group v-model="pay">
          <van-cell-group class="pay-type" >
            <van-cell title="单选框 1" clickable @click="radio = '1'">
              <template slot="title" >
                <img src="@/assets/images/wechat-pay.png" >
                <span>微信支付</span>
              </template>
              <van-radio slot="right-icon" name="1" />
            </van-cell>
            <van-cell clickable @click="radio = '2'">
              <template class="pay-type-icon" slot="title" >
                <img src="@/assets/images/zhifubao-pay.png" >
                <span>支付宝支付</span>
              </template>
              <van-radio slot="right-icon" name="2" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-button class="btn" :loading="payLoading" type="danger" :loading-text="loadingText" >确认支付</van-button>
        <div class="cancel" @click="isShowPopup = false" >取消</div>
      </div>
    </van-popup>
    -->
  </div>
</template>

<script>
import Vue from 'vue'
import { payOrderId } from '@/libs/ds-bridge'
import WechatAuth from '@/libs/wechat-auth'
import { AppType, getSearchQueryParams, ConstConfig, varConfig, ImageFormat } from '@/utils/index'
import { setToken, getToken, getWXInfo, removeToken } from '@/libs/cookie-storage'
import { getPassport } from '@/libs/passport'
import { getLiveBroadcastPlan, createLiveBroadcastOrder, getWPUnifiedOrder } from '@/api/pay'
import { Row, Col, RadioGroup, Radio, Field, Toast, Popup, Button, Stepper } from 'vant'
Vue.use(Row).use(Col).use(RadioGroup).use(Radio).use(Field).use(Toast).use(Popup).use(Button).use(Stepper)
const matchNumber = [1, 3, 5, 10, 15, 20]
const appid = ConstConfig.wxAppId
const wechatAuth = new WechatAuth({
  appid: appid
})
export default {
  name: 'Buy',
  data() {
    return {
      pay: '1',
      number: null,
      isShowPopup: false,
      payLoading: false,
      loadingText: '加载中...',
      baselinePrice: null,
      list: [],
      couponPrice: 0,
      alreadyPurchasedCount: 0,
      couponFlag: null,
      preferentialMoney: 0,
      payMoney: 0,
      count: 0,
      showBuyCount: 0,
      showCouponCount: 0,
      openId: null,
      appVersion: '',
      weChatCode: null
    }
  },
  created() {
    this.getLiveBroadcastPlan()
    this.openId = getWXInfo() && getWXInfo().openId
    let query = getSearchQueryParams()
    this.weChatCode = query.code ? query.code : wechatAuth.getAuthCode()
    this.weChatCode = this.weChatCode !== '' ? this.weChatCode : null
    if (AppType.isInWeChat() && this.weChatCode) {
      this.getWxToken(this.weChatCode)
    } else if (AppType.isInApp() && query.passport) {
      setToken(query.passport)
    }
    if (query.appVersion) {
      this.appVersion = query.appVersion
    }
  },
  mounted() {
    this.shareData = {
      title: '斑马赛事通，人人都能用得起的智能体育直播工具',
      link: window.location.href,
      image: ImageFormat.squareImageView('FoKGFlZjttio9HG_TfoBBXBnQLl3', 120),
      abstract: '设备简单无门槛，包装专业秒杀普通直播，智能记录、自动生成精彩集锦'
    }
    this.wxShare(this.shareData)
  },
  computed: {},
  methods: {
    getWxToken() {
      getPassport()
    },
    getLiveBroadcastPlan() {
      let params = {
        pricePlanId: 3
      }
      if (!(process.env.NODE_ENV === 'production' && process.env.NODE_ENV === 'pre')) {
        params.mockupCase = 1 // 假数据才用到的参数 真正上线后须去掉
      }
      getLiveBroadcastPlan(params).then(response => {
        // console.log(response)
        if (response) {
          let arr = []
          let arrFilter = []
          let data = response.data
          this.baselinePrice = data.baselinePrice / 100
          this.couponPrice = data.couponPrice / 100
          if (data.alreadyPurchasedCount) {
            this.alreadyPurchasedCount = data.alreadyPurchasedCount
          } else {
            this.alreadyPurchasedCount = 0
          }
          this.couponFlag = data.couponFlag
          arr = matchNumber.map((number, index) => {
            return {
              number: number,
              money: this.toDecimal2(number * this.baselinePrice),
              active: false
            }
          })
          arr.forEach((item, index) => {
            arrFilter.push(item)
            if ((index + 1) % 3 === 0 && index !== 0) {
              this.list.push(arrFilter)
              arrFilter = []
            }
          })
        }
      })
    },
    createLiveBroadcastOrder() {
      if (!this.showBuyCount || this.showBuyCount <= 0) {
        Toast('请选择购买场次')
        return
      }
      if (!AppType.isInApp() && !AppType.isInWeChat()) {
        Toast('请在APP或微信中创建订单')
        return
      }
      let params = {
        pricePlanId: 3,
        amount: this.count
      }
      createLiveBroadcastOrder(params).then(response => {
        if (response) {
          let orderId = response.data.orderId
          if (AppType.isInApp()) {
            this.appPay(orderId)
          } else if (AppType.isInWeChat()) {
            this.weChatPay(orderId)
          } else {
            this.h5Pay(orderId)
          }
          /*
          let orderId = response.data.orderId
          if (AppType.isInApp()) {
            this.appPay(orderId)
          } else if (AppType.isInWeChat()) {
            this.weChatPay(orderId)
          } else {
            this.h5Pay(orderId)
          }
          */
        }
        /*
         * if (response) {
          let orderId = response.data.orderId
          if(AppType.isInLiveApp()) {
            this.appPay(orderId)
          } else if ((AppType.isInApp() && AppType.isInAndroid()) || (AppType.isInApp() && !AppType.isInAndroid() && this.appVersion === '3.3.3')) {
            this.appPay(orderId)
          } else if(AppType.isInWeChat()) {
            this.weChatPay(orderId)
          } else {
            this.h5Pay(orderId)
          }
        }
         */
      })
    },
    appPay(orderId) {
      payOrderId(orderId)
    },
    h5Pay(orderId) {
      let params = {
        orderId: orderId,
        tradeType: 'MWEB'
      }
      getWPUnifiedOrder(params).then(response => {
        const data = response.data
        if (data.payInfo) {
          this.goPurchase(data.payInfo.mwebUrl)
        } else {
          Toast('购买失败，服务器错误刷新页面后在尝试')
        }
      })
    },
    goPurchase(mwebUrl) {
      const url = mwebUrl + '&redirect_url=' + encodeURIComponent(window.location.href)
      window.location.assign(url)
    },
    weChatPay(orderId) {
      if (!this.openId) {
        Toast('页面异常，请刷新后在尝试')
        return
      }
      let params = {
        openId: this.openId,
        orderId: orderId,
        tradeType: 'JSAPI'
      }
      getWPUnifiedOrder(params).then(response => {
        if (response) {
          const data = response.data.payInfo
          this.hrefWechatPay(data)
        } else {
          Toast('购买失败，服务器错误刷新页面后在尝试')
        }
      })
    },
    hrefWechatPay(payInfo) {
      const callbackUrl = this.callbackUrl()
      const payUrl = varConfig.payUrl + '?' + this.queryObjectToString({
        t: Date.now(),
        payInfo: JSON.stringify(payInfo),
        redirectUrl: callbackUrl
      })
      console.log(payUrl, callbackUrl)
      // console.log('购买成功')
      window.location.assign(payUrl)
    },
    selectNumber(number) {
      const token = getToken() || getSearchQueryParams().passport
      if (AppType.isInWeChat() && !token) {
        getPassport()
        return
      } else if (AppType.isInApp() && !token) {
        this.$router.push({
          name: 'Login',
          query: { redirect: this.$route.fullPath }
        })
      } else if (AppType.isInWeChat() && token && !this.openId) {
        removeToken()
        getPassport()
        return
      } else if (!token) {
        this.$router.push({
          name: 'Login',
          query: { redirect: this.$route.fullPath }
        })
      }
      this.list.forEach(item => {
        item.forEach(obj => {
          obj.active = false
        })
      })
      let type = typeof number
      if (type === 'string') {
        this.number = number
        this.money(number)
        this.showBuyCount = number
      } else {
        number.active = !number.active
        this.number = ''
        this.money(number.number)
        this.showBuyCount = number.number
      }
    },
    toDecimal2(x) {
      let f = parseFloat(x)
      if (isNaN(f)) {
        return false
      }
      f = Math.round(x * 100) / 100
      let s = f.toString()
      let rs = s.indexOf('.')
      if (rs < 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + 2) {
        s += '0'
      }
      return s
    },
    money(count) {
      this.count = count
      let number = Number(count) // 当前场次
      let alreadyPurchasedCount = Number(this.alreadyPurchasedCount) // 历史场次
      let preferentialNumber = 19
      if (this.couponFlag === 1) {
        //  console.log('享受优惠次数', number) // 全部优惠
        this.preferential(0, number)
        this.showCouponCount = number
      } else {
        if (alreadyPurchasedCount > preferentialNumber) {
          // console.log('享受优惠场次', number) // 全部优惠
          this.preferential(0, number)
          this.showCouponCount = number
        } else {
          if (number + alreadyPurchasedCount < (preferentialNumber + 1)) {
            // console.log('全价购买', number) // 全部 不优惠
            this.preferential(number, 0)
            this.showCouponCount = 0
          } else {
            // console.log('享受优惠场次', sum, '不能优惠场次', noPreferentialNumber)
            // let sum = (number + alreadyPurchasedCount) - preferentialNumber
            // let noPreferentialNumber = number - sum
            // this.preferential(noPreferentialNumber, sum)
            // this.showCouponCount = sum
            this.preferential(0, number)
            this.showCouponCount = number
          }
        }
      }
    },
    preferential(number = 0, preNumber = 0) {
      this.preferentialMoney = (preNumber * this.baselinePrice) - (preNumber * this.couponPrice)
      this.payMoney = (number * this.baselinePrice) + (preNumber * this.couponPrice)
    },
    queryObjectToString(params) {
      var ret = []
      params = params || {}
      for (var key in params) {
        if (params.hasOwnProperty(key)) {
          ret.push(key + '=' + encodeURIComponent(params[key]))
        }
      }
      return ret.join('&')
    },
    callbackUrl() {
      const location = window.location
      // const url = location.protocol + '//' + location.host + location.pathname
      return location.href
    },
    reloadHref() {
      window.location.replace('http://a.app.qq.com/o/simple.jsp?pkgname=cn.snsports.banma')
    },
    routerLiveService() {
      this.$router.push({
        path: '/live-service'
      })
    },
    goAgent () {
      this.$router.push({ name: 'BDAgent' })
    }
  }
}
</script>

<style lang="stylus" >
  #buy
    width 100%
    /*height: 100%;*/
    padding-bottom: 115px;
    background-color #FAFAFA
    .select
      height: 84px;
      display flex;
      padding: 10px 0 0;
      flex-wrap: wrap;
      .block
        flex: 1
        height: 100%
        margin: 0;
        background:rgba(255,255,255,0.05);
        border-radius:2px;
        border:1px solid rgba(248,248,248,1);
        display flex
        flex-flow column
        justify-content center
        align-items center
        div:first-child
          font-size:30px;
          font-weight:400;
          color:rgba(74,74,74,1);
          span
            font-size: 16px;
        div:last-child
          font-size:14px;
          font-weight:400;
          color:rgba(251,87,84,1);
      .block:nth-child(odd)
        margin: 0 10px;
      .block-select
        background:rgba(251,87,84,0.05);
        border-radius:2px;
        border:1px solid rgba(251,87,84,1);
    .customize-number
      background-color white
      padding: 20px 10px;
      display flex
      justify-content space-between
      .van-cell
        padding 0;
        .van-field__body
          input
            text-align right
            font-size:14px;
            font-weight:400;
            color: #000000;
      div:last-child
        font-size:16px;
        font-weight:400;
        color:rgba(74,74,74,1);
      div:last-child
        display flex
        span
          font-size:14px;
          font-weight:400;
          color:rgba(218,218,218,1);
          padding-right 10px
        i
          display block
          width:9px;
          height:10px;
          img
            width:9px;
            height:10px;
    .det
      padding: 20px 10px;
      font-size:14px;
      font-weight:400;
      color:rgba(74,74,74,1);
      line-height:20px;
      background-color white
      margin-top 10px
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(74,74,74,1);
        span
          color: #000
          padding: 0 5px;
    .pay-type
      .van-cell
        padding: 15px;
        .van-cell__title
          display flex
          align-items center
          font-size:14px;
          font-weight:400;
          color:rgba(74,74,74,1)
          img
            height: 25px
            padding-right 10px
      .van-cell:not(:last-child)::after
        left 0
    .van-hairline--top-bottom::after
      border-width 0
    .coupon
      background-color white
      padding: 20px 10px;
      display flex
      .img
        padding-right: 10px
        img
          width 22px
          height: 22px
      .info
        width 100%
        .money
          padding-right 0
          display flex
          font-size:16px;
          font-weight:400;
          color:rgba(0,0,0,1);
          justify-content: space-between;
          div:last-child
            font-size:16px;
            font-weight:500;
            color:rgba(234,74,71,1);
          .arrow
            width: 6px;
            height: 10px;
            position: relative;
            right: 10px;
            top: 1px;
      .text
        padding-top 5px
        font-size:14px;
        font-weight:400;
        color:rgba(74,74,74,1);
    .footer
      position fixed
      bottom: 0
      left 0
      width 100%
      z-index 1
      .footer-coupon
        height: 52px
        line-height 52px
        background:rgba(255,246,246,1);
        font-size:16px;
        font-weight:400;
        color:rgba(0,0,0,1);
        text-align center
        span
          padding-right 10px
        .original
          color: #4A4A4A;
          font-size: 12px;
          text-decoration: line-through;
    .footer-pay
      height:65px;
      width 100%
      line-height 65px;
      font-size:20px;
      font-weight:400;
      text-align center
      background:rgba(255,255,255,1);
      color:rgba(196,196,196,1);
    .footer-pay-active
      background:rgba(234,74,71,1);
      color:rgba(255,255,255,1);
    .line
      width 100%
      height 10px
      background-color #FAFAFA
    .pay-popup
      .pay-popup-top
        padding: 30px 10px;
        text-align center
        p
          font-size:14px;
          font-weight:400;
          color:rgba(74,74,74,1);
          margin: 0;
        .pay-popup-coupon
          font-size:25px;
          font-family:PingFangSC;
          font-weight:500;
          color:rgba(0,0,0,1);
          line-height:36px;
          span
            font-size: 18px
            padding-right 5px
      .btn
        width:285px;
        height:65px;
        line-height 65px
        text-align center
        background:rgba(234,74,71,1);
        border-radius:2px;
        font-size:20px;
        font-weight:400;
        color:rgba(255,255,255,1);
        position: absolute
        bottom: 60px
        left: 50%
        transform translate(-50%, 0)
      .cancel
        text-align center
        color: #4A4A4A
        bottom: 25px
        position absolute
        left: 50%
        transform translate(-50%, 0)
    .live-service
      padding: 15px 0px;
      .live-edit
        display flex
        align-items: center;
        background-color white
        padding: 15px;
      p
        width calc(100% - 65px);
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:17px;
        margin: 0;
        padding-right: 10px;
      .btn-router
        width:65px;
        height: auto;
        padding: 5px 0px;
        background:rgba(255,116,114,1);
        border-radius:17px;
        font-size:10px;
        font-weight:400;
        color:rgba(255,255,255,1);
        text-align center
    .prompt
      .text
        span
          color: #FF8883
          margin: 0 5px;
          border-bottom: 2px solid #FF8883
    .online-advisory
      position: fixed;
      bottom:120px;
      right:8px;
      /*background: url("../images/client-chat.png") center no-repeat;*/
      /*background: url("/assets/images/human-services.png") center no-repeat;*/
      /*background-color:#cc3232;*/
      -webkit-background-size: cover;
      /*background-size: 70%;*/
      width:95px;
      height:46px;
      border-radius:37px;
      img
        width 100%
</style>



// WEBPACK FOOTER //
// src/pages/buy/index.vue